import classNames from 'classnames';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage, injectIntl, intlShape} from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import Box from '../box/box.jsx';
import ProjectLoader from '../../containers/project-loader.jsx';
import ProjectSaver from '../../containers/project-saver.jsx';
import AutoProjectSaver from '../../containers/project-auto-saver.jsx';
import WhitelistButton from '../../containers/whitelist-button.jsx';
import AutoJudgementSaveBtn from '../../containers/auto-judgement-save-btn.jsx';
import Menu from '../../containers/menu.jsx';
import Button from '../button/button.jsx';

import {setPlayer} from '../../reducers/mode';
import {selectLocale} from '../../reducers/locales';

import {
    fileMenuOpen,
    editMenuOpen,
    openFileMenu,
    openLanguageMenu,
    closeLanguageMenu,
    closeFileMenu,
    languageMenuOpen,
    accountMenuOpen
} from '../../reducers/menus';
import {loginModalOpen, closeLogin} from '../../reducers/modals';
import {getAccountInfo} from '../../reducers/account-info';
import {
    SAVE_STATE_NONE,
    SAVE_STATE_DONE,
    SAVE_STATE_AUTO_SAVE_DONE,
    SAVE_STATE_FAIL,
    SAVE_STATE_AUTO_SAVE_FAIL,
    SAVE_STATE_SAVING,
    SAVE_STATE_AUTO_SAVING
} from '../../reducers/homework-save';
import {getPlatform, isMobile} from '../../lib/platform';
import {getMode, isTutor, isTeacherMode, isCreateMode,isAutoJudgementConfig} from '../../lib/hetao-mode';
import {backToVideo} from '../../lib/app/api';
import {getParameterByName} from '../../utils/tools';

import ModalLoginComponent from '../login-modal/login-modal.jsx';
import ProjectPerformance from './project-performance.jsx'
import styles from './menu-bar.css';
import iconFont from '../../css/iconfont.css';

import scratchLogo from './hetao-logo.png';
import downIcon from './icon--down.svg';
import backIcon from './icon--back.svg';
import videoIcon from './icon-video-btn.svg';

const messages = defineMessages({
    untitled: {
        id: 'gui.menubar.untitled',
        defaultMessage: '自由创作',
        description: 'default untitled text'
    },
    checkVideo: {
        id: 'gui.menubar.checkVideo',
        defaultMessage: '看视频',
        description: 'text for jump to video'
    }

});
const ModalLogin = ({
    isModalLoginOpen,
    children,
    onRequestClose,
    overlayClassName,
    fullScreen

}) => (
    <ModalLoginComponent
        fullScreen={fullScreen}
        isOpen={isModalLoginOpen}
        overlayClassName={overlayClassName}
        onRequestClose={onRequestClose}

    >
        {children}
    </ModalLoginComponent>
);

ModalLogin.propTypes = {
    children: PropTypes.node,
    fullScreen: PropTypes.bool,
    isModalLoginOpen: PropTypes.bool,
    onRequestClose: PropTypes.func.isRequired,
    overlayClassName: PropTypes.string
};
const MenuBarMenu = ({
    children,
    onRequestClose,
    open,
    place = 'right'
}) => (
    <Menu
        className={styles.menu}
        open={open}
        place={place}
        onRequestClose={onRequestClose}
    >
        {children}
    </Menu>
);
MenuBarMenu.propTypes = {
    children: PropTypes.node,
    onRequestClose: PropTypes.func,
    open: PropTypes.bool,
    place: PropTypes.oneOf(['left', 'right'])
};


const VideoCheckButton = ({onOpenVideoCheck, formatMessage}) => (
    <Button
        className={styles.videoCheckBtn}
        iconClassName={styles.videoCheckIcon}
        iconSrc={videoIcon}
        onClick={onOpenVideoCheck}
    >
        {formatMessage(messages.checkVideo)}
    </Button>
);
VideoCheckButton.propTypes = {
    formatMessage: PropTypes.func,
    onOpenVideoCheck: PropTypes.func
};

const MenuBar = props => (
    <Box className={styles.menuBar}>
        <div className={styles.mainMenu}>
            {isMobile() ? <div
                className={classNames(styles.menuBarItem)}
                style={{marginLeft: '0'}}
                onClick={props.onBackCheck}
            >
                <Button iconSrc={backIcon} />
            </div> : null}

            {
                isMobile() ? null : <div
                    className={classNames(styles.menuBarItem, styles.menuBarLogoItem)}
                >
                    <img
                        alt="hetao"
                        className={styles.scratchLogo}
                        draggable={false}
                        src={scratchLogo}
                    />
                </div>

            }

            {
                props.currentLocale === 'zh-cn' ?
                    (<div
                        className={classNames(styles.menuBarItem, styles.hoverable)}
                        data-locale={'en'}
                        onClickCapture={props.onChangeLanguage}
                    >
                        <i className={classNames(iconFont.iconfont, iconFont.iconYingwen)} />
                        <span>{'英文'}</span>
                    </div>) :
                    (<div
                        className={classNames(styles.menuBarItem, styles.hoverable)}
                        data-locale={'zh-cn'}
                        onClickCapture={props.onChangeLanguage}
                    >
                        <i className={classNames(iconFont.iconfont, iconFont.iconZhongwen)} />
                        <span>{'Chinese'}</span> </div>)
            }
            <ProjectLoader
                mode={'reload'}
            >
                {loadProject => (
                    <div
                        className={classNames(styles.menuBarItem, styles.hoverable)}
                        onClick={loadProject}
                    >
                        <i className={classNames(iconFont.iconfont, iconFont.iconZhongxinkaishi)} />
                        <FormattedMessage
                            defaultMessage="Redo"
                            description="Text for project redo"
                            id="gui.menuBar.redo"
                        />
                    </div>

                )}
            </ProjectLoader>
            <ProjectSaver mode={'saveHomework'}>{saveProject => {
                if (props.saveState === SAVE_STATE_NONE) {
                    return (
                        <div
                            className={classNames(styles.menuBarItem, styles.hoverable, 'btn-save-homework')}
                            onClick={saveProject}
                        >
                            <i className={classNames(iconFont.iconfont, iconFont.iconBaocun)} />
                            <FormattedMessage
                                defaultMessage="Save"
                                description="Text for project save remote"
                                id="gui.menuBar.save"
                            />
                        </div>
                    );
                }

                return (
                    <div className={classNames(styles.menuBarItemSave)}>
                        <i
                            className={styles.iconSave}
                            state={props.saveState}
                        />
                        {(() => {
                            if (props.saveState === SAVE_STATE_SAVING) {
                                return (<FormattedMessage
                                    defaultMessage="Saving..."
                                    description="Text for project save remote"
                                    id="gui.menuBar.saving"
                                />);
                            } else if (props.saveState === SAVE_STATE_DONE) {
                                return (<FormattedMessage
                                    defaultMessage="Save Done"
                                    description="Text for project save remote"
                                    id="gui.menuBar.saved"
                                />);
                            } else if (props.saveState === SAVE_STATE_FAIL) {
                                return (<FormattedMessage
                                    defaultMessage="Save Failed"
                                    description="Text for project save remote"
                                    id="gui.menuBar.saveFailed"
                                />);
                            } else if (props.saveState === SAVE_STATE_AUTO_SAVING) {
                                return (<FormattedMessage
                                    defaultMessage="Saving..."
                                    description="Text for project save remote"
                                    id="gui.menuBar.saving"
                                />);
                            } else if (props.saveState === SAVE_STATE_AUTO_SAVE_DONE) {
                                return (<FormattedMessage
                                    defaultMessage="Save Done"
                                    description="Text for project save remote"
                                    id="gui.menuBar.saved"
                                />);
                            } else if (props.saveState === SAVE_STATE_AUTO_SAVE_FAIL) {
                                return (<FormattedMessage
                                    defaultMessage="Save Failed"
                                    description="Text for project save remote"
                                    id="gui.menuBar.saveFailed"
                                />);
                            }
                        })()
                        }
                    </div>);
            }}
            </ProjectSaver>
            {getPlatform() === 'APP' ? null : <div
                className={classNames(styles.menuBarItem, styles.hoverable, styles.menuDown)}
                onClickCapture={props.onOpenFileMenu}
            >
                <img
                    alt="dropdown"
                    className={styles.downIcon}
                    draggable={false}
                    src={downIcon}
                />
                {
                    <div
                        className={styles.dropdownMenu}
                        style={props.fileMenuOpen ? {display: 'block'} : {display: 'none'}}
                        onClickCapture={props.onCloseFileMenu}
                    >
                        <MenuBarMenu
                            open
                            onRequestClose={props.onCloseFileMenu}
                        >
                            <ProjectSaver>
                                {(saveProject, saveProps) => (
                                    <li
                                        onClick={saveProject}
                                        {...saveProps}
                                    >
                                        <i />
                                        <FormattedMessage
                                            defaultMessage="Save to your computer"
                                            description="Menu bar item for downloading a project to your computer"
                                            id="gui.menuBar.downloadToComputer"
                                        />
                                    </li>
                                )}
                            </ProjectSaver>
                            <ProjectLoader>{(renderFileInput, loadProject, loadProps) => (
                                <li
                                    onClick={loadProject}
                                    {...loadProps}
                                >
                                    <i />
                                    <FormattedMessage
                                        defaultMessage="Load from your computer"
                                        description="Menu bar item for uploading a project from your computer"
                                        id="gui.menuBar.uploadFromComputer"
                                    />
                                    {renderFileInput()}
                                </li>)}
                            </ProjectLoader>
                        </MenuBarMenu>
                    </div>
                }
            </div>}
        </div>
        <div className={styles.projectTitle}>
            <p
                className={styles.projectTitleInput}
            >
                {props.title === '' ? props.intl.formatMessage(messages.untitled) : props.title}
            </p>
        </div>

        {
            isTeacherMode() && <ProjectPerformance />
        }

        {

            // ipad version add videoCheckButton
            isMobile() && getMode() === 'STUDENT' && !isCreateMode() && !getParameterByName('homeworkId') ?
                <VideoCheckButton
                    formatMessage={props.intl.formatMessage}
                    onOpenVideoCheck={backToVideo}
                /> : null
        }
        {
            (isTeacherMode() && !isAutoJudgementConfig()) ?
            <WhitelistButton
                    text='保存答案'
                    onClick={props.onSaveAnswer}
                /> : null
        }
        {
            (isTeacherMode() && !isAutoJudgementConfig()) ?
                <WhitelistButton
                    text={(props.vm.toolboxXML || props.isEdit) ? '编辑白名单' : '建立白名单'}
                    onClick={props.onOpenWhiteList}
                /> : null
        }
        {
            isAutoJudgementConfig() ? <AutoJudgementSaveBtn vm={props.vm} text="保存配置"/> : null
        }
        {
            isTeacherMode() ? null : (
                <ProjectSaver mode={'submitHomework'}>{saveProject => (
                    <div
                        className={classNames(styles.menuBarSubmitItem, styles.menuBarItem, styles.hoverable)}
                        onClick={props.isSubmitingHomework ? null : saveProject}
                    >
                        <div
                            className={classNames(styles.menuBarSubmitItemBtn,
                                {[styles.loading]: props.isSubmitingHomework})}
                        >
                            <FormattedMessage
                                defaultMessage="Submit"
                                description="Text for submit homework remote"
                                id="gui.menuBar.submitHomework"
                            />
                        </div>
                    </div>
                )}</ProjectSaver>
            )
        }
        {isTeacherMode() || isCreateMode() || isTutor() ? null : <AutoProjectSaver />}
        <div>
            {
                props.loginModalOpen ?
                    <ModalLogin
                        isModalLoginOpen={props.loginModalOpen}
                        onRequestClose={props.onCloseLogin}
                    >
                        <div className={styles.iframeLogin}>
                            <iframe
                                allowTransparency="true"
                                frameBorder="0"
                                height="400px;"
                                scrolling="no"
                                src={props.accountInfo.loginUrl}
                                width="300px"
                            />
                        </div>
                    </ModalLogin> : null
            }
        </div>
    </Box>
);

MenuBar.propTypes = {
    accountInfo: PropTypes.shape({
        avatar: PropTypes.string,
        isLogin: PropTypes.bool,
        loginUrl: PropTypes.string,
        nickname: PropTypes.string,
        userId: PropTypes.number

    }),
    currentLocale: PropTypes.string,
    fileMenuOpen: PropTypes.bool,
    intl: intlShape,
    isEdit: PropTypes.bool,
    isRtl: PropTypes.bool,
    isSubmitingHomework: PropTypes.bool,
    loginModalOpen: PropTypes.bool,
    onBackCheck: PropTypes.func,
    onChangeLanguage: PropTypes.func.isRequired,
    onCloseFileMenu: PropTypes.func,
    onCloseLogin: PropTypes.func.isRequired,
    onOpenFileMenu: PropTypes.func,
    onOpenWhiteList: PropTypes.func,
    saveState: PropTypes.string,
    sessionExists: PropTypes.bool,
    title: PropTypes.string,
    username: PropTypes.string,
    vm: PropTypes.shape({
        toolboxXML: PropTypes.string
    }),
    onSaveAnswer: PropTypes.func
};

const mapStateToProps = state => ({
    currentLocale: state.locales.locale,
    vm: state.scratchGui.vm,
    fileMenuOpen: fileMenuOpen(state),
    editMenuOpen: editMenuOpen(state),
    isRtl: state.locales.isRtl,
    isSubmitingHomework: state.scratchGui.modals.homeworkSubmiting,
    languageMenuOpen: languageMenuOpen(state),
    loginModalOpen: loginModalOpen(state),
    accountInfo: getAccountInfo(state),
    accountMenuOpen: accountMenuOpen(state),
    lessonId: state.scratchGui.homework.lessonId,
    sessionExists: state.session && typeof state.session.session !== 'undefined',
    title: state.scratchGui.homework.title,
    toolboxXML: state.scratchGui.toolbox.toolboxXML,
    saveState: state.scratchGui.homeworkSave.saveState,
    username: state.session && state.session.session && state.session.session.user ?
        state.session.session.user.username : null
});

const mapDispatchToProps = dispatch => ({
    onChangeLanguage: e => {
        e.stopPropagation();
        const locale = e.currentTarget.dataset.locale;
        dispatch(selectLocale(locale));
        document.documentElement.lang = locale;
    },
    onClickLanguage: () => dispatch(openLanguageMenu()),
    onOpenFileMenu: () => dispatch(openFileMenu()),
    onRequestCloseLanguage: () => dispatch(closeLanguageMenu()),
    onSeeCommunity: () => dispatch(setPlayer(true)),
    onCloseLogin: () => dispatch(closeLogin()),
    onCloseFileMenu: () => dispatch(closeFileMenu())

});

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(MenuBar));
